const Sorter = (($) => {
    const NAME = 'sorter';
    const DATA_KEY = `bs.${NAME}`;
    const JQUERY_NO_CONFLICT = $.fn[NAME];

    const SortDirection = {
        None: '',
        Ascending: 'asc',
        Descending: 'desc'
    }

    const Default = {
        sortUrl: null,
        sortVariable: 'orderBy',
        sortTarget: null,
        sortValue: null,
        sortClassName: 'sorting',
        sortAscClassName: 'sorting-asc',
        sortDescClassName: 'sorting-desc'
    };

    const Selector = {
        CLASS_NAME: `.js-${NAME}`
    }

    class Sorter {
        constructor(element, config) {
            this._config = config;
            this._element = element;
            this._$fields = $(element).find('[data-sort-name]');  // fyi can't have nested sort
            this._shift = false;
            this._sortData = [];

            const self = this;
            this._$fields.each(function () {
                self._init($(this));
            });

            // keep track of shift key being pressed
            $(document)
                .on('keydown', (e) => {
                    // keep track of shift key being pressed
                    const evt = e || window.event,
                        keyCode = evt.keyCode || evt.which;

                    if (keyCode === 16) {
                        this._shift = true;
                    }
                })
                .on('keyup', () => this._shift = false);
        }

        _init($field) {
            const name = $field.data('sort-name').toLowerCase();

            this._none($field);

            if (this._config.sortValue) {
                const self = this;
                $.each(this._config.sortValue.toLowerCase().split(','), function () {
                    let parseName = $.trim(this);

                    if (parseName === name || parseName === `${name} ${SortDirection.Ascending}`) {
                        self._ascending($field);
                    } else if (parseName === `${name} ${SortDirection.Descending}`) {
                        self._descending($field);
                    }
                });
            }

            $field.on('click', (e) => this._sort(e, $field));
        }

        _none($field) {
            $field
                .removeClass(`${this._config.sortAscClassName} ${this._config.sortDescClassName}`)
                .addClass(this._config.sortClassName)
                .data('sort-direction', SortDirection.None);

            this._sortData = this._sortData.filter(data => data.name !== $field.data('sort-name'));
        }

        _ascending($field) {
            $field
                .removeClass(`${this._config.sortClassName} ${this._config.sortDescClassName}`)
                .addClass(this._config.sortAscClassName)
                .data('sort-direction', SortDirection.Ascending);

            this._sortData.push({
                name: $field.data('sort-name'),
                direction: SortDirection.Ascending
            });
        }

        _descending($field) {
            $field
                .removeClass(`${this._config.sortClassName} ${this._config.sortAscClassName}`)
                .addClass(this._config.sortDescClassName)
                .data('sort-direction', SortDirection.Descending);

            this._sortData.push({
                name: $field.data('sort-name'),
                direction: SortDirection.Descending
            });
        }

        _sort(e, $field) {
            e.preventDefault();

            const name = $field.data('sort-name'),
                found = this._sortData.find(item => item.name === name);
            
            let direction = found ? found.direction : SortDirection.None;

            if (this._shift) {
                // multi column sorting
                this._sortData = this._sortData.filter((item) => item.name !== name);

                if (direction === SortDirection.Ascending) {
                    this._descending($field);
                } else if (direction === SortDirection.Descending) {
                    this._none($field);
                } else {
                    this._ascending($field);
                }
            } else {
                // single column sorting
                this._sortData = [];
                const self = this;
                this._$fields.each(function() {
                    const $element = $(this);
                    if ($element.data('sort-name') !== name) {
                        self._none($element);
                    }
                });
                
                if (direction === SortDirection.Ascending) {
                    this._descending($field);
                } else {
                    this._ascending($field);
                }
            }

            let value = '';
            $.each(this._sortData, function() {
                value += `, ${this.name} ${this.direction}`;
            });

            const regex = new RegExp(`${this._config.sortVariable}=*[^&#]*`),
                url = this._config.sortUrl.replace(regex, `${this._config.sortVariable}=${value.substring(2)}`);

            $.get(url, (data) => $(this._config.sortTarget).html(data));
        }

        dispose() {
            $.removeData(this._element, DATA_KEY);
            this._config = null;
            this._element = null;
        }

        static _jQueryInterface() {
            return this.each(function () {
                const $this = $(this);
                let data = $this.data(DATA_KEY);
                const config = $.extend({}, Default, $this.data());
                if (!data) {
                    data = new Sorter(this, config);
                    $this.data(DATA_KEY, data);
                }
            });
        }
    }

    $(() => Sorter._jQueryInterface.call($(Selector.CLASS_NAME)));
    $(document).ajaxStop(() => Sorter._jQueryInterface.call($(Selector.CLASS_NAME)));

    $.fn[NAME] = Sorter._jQueryInterface;
    $.fn[NAME].Constructor = Sorter;
    $.fn[NAME].noConflict = function () {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return Sorter._jQueryInterface;
    }

    return Sorter;
})(jQuery);